import  { type NodeMouseEvent,MarkerType } from '@vue-flow/core';
// import { useEditorStore } from '@/stores/editorStore';
// import { useWorkflowStore } from '@/stores/workflowStore';
import { ElMessage } from '@/plugins/elementPlus';
import { v4 as uuidv4 } from 'uuid';

import {find} from 'es-toolkit/compat'

function nodeDoubleClick(event: NodeMouseEvent,setActiveNodeId:any) {
  setActiveNodeId(event.node.id);
  
  // console.log('nodeDoubleClick', editorStore.activeNodeId, event);
}

function onConnect(params: any,addEdge:any,findNode:any,edges:any,edgeOptions:any) {

  
  // "源节点ID" 和"目标节点ID" 不能相同
  const sourceNode = findNode(params.source);
  const targetNode = findNode(params.target);

  if (edges.filter((edge) =>{return edge.source==params.source&&edge.target==params.target&&edge.sourceHandle==params.sourceHandle&&edge.targetHandle==params.targetHandle} ).length > 0) {
    ElMessage.warning('重复连接');
    return
  }

  try {
    // 正确：取目标节点输入口的 allowTypes，源节点输出口的 dataType
    const allowTypes = find(targetNode?.data?.handles?.inputs,{id:params.targetHandle})?.allowTypes as string[] | undefined;
    const dataType = find(sourceNode?.data?.handles?.outputs,{id:params.sourceHandle})?.dataType as string | undefined;

    // 类型校验：当目标口有限定且源数据类型已知时才进行严格检查
    if (allowTypes && dataType) {
      if (allowTypes.length > 0 && !allowTypes.includes(dataType)) {
        ElMessage.warning('数据类型不匹配');
        return;
      }
    }

    const edgeId = uuidv4();

    // 根据数据类型选择连线颜色
    let lineColor = edgeOptions.lineColor; // 默认灰色（数据线）
    let arrowColor = edgeOptions.arrowColor; // 默认箭头颜色
    
    // 判断是否为执行类型连线
    if (dataType === 'flow' || dataType === 'signal' || dataType === 'trigger') {
      lineColor = '#31C24A'; // 浅绿色（执行线）
      arrowColor = '#31C24A';
    }

    // 添加连接并应用样式
    addEdge({
      id: edgeId,
      source: params.source,
      sourceHandle: params.sourceHandle,
      target: params.target,
      style: { stroke: lineColor, strokeWidth: edgeOptions.lineWidth },
      // 将箭头放在目标端，表示数据/执行流向目标节点
      markerEnd: {
        color: arrowColor,
        type: MarkerType.Arrow,
      },
      targetHandle: params.targetHandle,
    })

  } catch (error) {
    ElMessage.warning('连接异常');
    return;
  }

}

function onEdgesChange(changes: any,removeEdge:any) {
  if (changes.length===0) {
    return;
  }
  changes.forEach((change:any) => {
    if (change.type === 'remove') {
      removeEdge(change.id)
  }});
}

function onNodeChange(changes:any,removeNode:any) {
  console.log(1);
  
  if (changes.length===0) {
    return;
  }
  changes.forEach((change:any) => {
    if (change.type === 'remove') {
     removeNode(change.id)
  }});
}

function onNodeDragStop(event: NodeMouseEvent,moveNode:any) {
 moveNode(event.node.id, event.node.position);
}

export { nodeDoubleClick, onConnect, onEdgesChange, onNodeDragStop,onNodeChange };
